/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteAgentsResponseContent
 */
export interface DeleteAgentsResponseContent {
    /**
     * 
     * @type {string}
     * @memberof DeleteAgentsResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the DeleteAgentsResponseContent interface.
 */
export function instanceOfDeleteAgentsResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteAgentsResponseContentFromJSON(json: any): DeleteAgentsResponseContent {
    return DeleteAgentsResponseContentFromJSONTyped(json, false);
}

export function DeleteAgentsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteAgentsResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function DeleteAgentsResponseContentToJSON(value?: DeleteAgentsResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

